import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Background"
});
const _hoisted_1 = {
  width: "58",
  height: "36",
  viewBox: "0 0 58 36",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.04",
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M10 0H24L14 36H0L10 0ZM34 0H43L33 36H24L34 0ZM58 0H53L43 36H48L58 0Z",
  fill: "#5587FF"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var background = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { background as default };
